import React from 'react';
import { useTranslation } from 'utils/modifiedTranslation';
import { getUserCondition } from 'modules/user/utils';
import { getQstack } from 'modules/questionnaire/helpers';
import HCPSelect from 'new-ui/Components/HCP/Select';
import app from 'new-ui/app';
import { GENERAL_DISEASE } from 'utils/constants/disease';
import { getQuestions } from 'new-ui/functions/getQuestions';
import { CheckEligibility } from './CheckEligibility';
import { questionPropTypes } from './questionPropTypes';

export const BoxBiomarkersQuestion = ({ onselect, user }) => {
  const { t } = useTranslation();

  const options = app.biomarkers.map(({ name, code }) => ({
    title: t(name),
    value: code,
  }));

  return (
    <div className="box-question-biomarkers">
      <div className="hcp-input-title">
        {t('general.biomarkers')}
      </div>
      <CheckEligibility />
      <div>
        <HCPSelect
          user={user}
          showAutofill
          renderOnSelect={false}
          useTags
          isMulti
          onselect={(v) => {
            const fetch = async () => {
              // !!! user mutation
              // eslint-disable-next-line no-param-reassign
              user.condition_profile.biomarkers = v || [];
              const condition = getUserCondition(user);
              if (condition && condition !== GENERAL_DISEASE) {
                const questions = await getQuestions(condition);
                // !!! user mutation
                // eslint-disable-next-line no-param-reassign
                user.condition_profile.qstack = getQstack({ questions, conditionProfile: user.condition_profile });
              }
              onselect(user.condition_profile.biomarkers);
              if (window._accordion) {
                window._accordion.render();
              }
            };
            fetch();
          }}
          options={options}
          initValue={user.condition_profile.biomarkers || ['none']}
        />
      </div>
    </div>
  );
};

BoxBiomarkersQuestion.propTypes = questionPropTypes;
